var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCancelicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10722_9178)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.48 9.14H28.95V6.09H27.43V4.57H25.9V3.05H22.86V1.52H19.81V0H12.19V1.52H9.14V3.05H6.09V4.57H4.57V6.09H3.05V9.14H1.52V12.19H0V19.81H1.52V22.86H3.05V25.9H4.57V27.43H6.09V28.95H9.14V30.48H12.19V32H19.81V30.48H22.86V28.95H25.9V27.43H27.43V25.9H28.95V22.86H30.48V19.81H32V12.19H30.48V9.14ZM25.9 21.33H24.38V22.86H22.86V24.38H18.29V22.86H19.81V21.33H21.33V19.81H19.81V18.29H13.71V21.33H12.19V19.81H10.67V18.29H9.14V16.76H7.62V15.24H6.09V13.71H7.62V12.19H9.14V10.67H10.67V9.14H12.19V7.62H13.71V10.67H22.86V12.19H24.38V13.71H25.9V21.33Z",
    fill: "#03BB15"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10722_9178"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelicon);
export default __webpack_public_path__ + "static/media/cancelicon.57b2cab25eaa515fbd5aa23e047f534f.svg";
export { ForwardRef as ReactComponent };